import {
  ActivityLogType,
  RemediationPriority,
  RemediationStatus,
} from "./constants";

export const RemediationTypeChip = {
  complexity: {
    0: { label: "Low", color: "feasibility_low" },
    1: { label: "Low", color: "feasibility_low" },
    2: { label: "Medium", color: "feasibility_medium" },
    3: { label: "High", color: "feasibility_high" },
  },
  remediationPriority: {
    0: { label: RemediationPriority[1], color: "priority_very_low" },
    1: { label: RemediationPriority[1], color: "priority_low" },
    2: { label: RemediationPriority[2], color: "priority_medium" },
    3: { label: RemediationPriority[3], color: "priority_high" },
    4: { label: RemediationPriority[4], color: "priority_high" },
    5: { label: RemediationPriority[5], color: "priority_critical" },
  },
  feasibility: {
    1: { label: "Very Low", color: "feasibility_very_low" },
    2: { label: "Low", color: "feasibility_low" },
    3: { label: "Medium", color: "feasibility_medium" },
    4: { label: "High", color: "feasibility_high" },
    5: { label: "Very High", color: "feasibility_very_high" }, // TODO change colors for 5
  },
  effectOnUserExperience: {
    Moderate: { label: "Moderate", color: "medium_effect_on_user_experience" },
    Drastic: { label: "Drastic", color: "highE_effect_on_user_experience" },
  },
  impact: {
    1: { label: "Very Low", color: "feasibility_very_low" },
    2: { label: "Low", color: "feasibility_low" },
    3: { label: "Medium", color: "feasibility_medium" },
    4: { label: "High", color: "feasibility_high" },
    5: { label: "Very High", color: "status_resolve" }, // TODO change colors for 5
  },
  controlPriority: {
    0: { label: "Scanning", color: "feasibility_scanning" },
    1: { label: "Low", color: "risk_low" },
    2: { label: "Medium", color: "risk_medium" },
    3: { label: "High", color: "risk_high" },
  },
  status: {
    [RemediationStatus.RESOLVED]: {
      label: "Resolved",
      color: "status_resolve",
    },
    [RemediationStatus.PARTIALLY_RESOLVED]: {
      label: "Partially Resolved",
      color: "status_partially_resolved",
    },
    [RemediationStatus.PENDING]: { label: "Pending", color: "status_pending" },
  },
  likelihood: {
    0: { label: "Low", color: "status_resolve" },
    1: { label: "Low", color: "status_resolve" },
    2: { label: "Medium", color: "feasibility_medium" },
    3: { label: "High", color: "feasibility_low" },
  },
  coverage: {
    1: { label: "Low", color: "feasibility_low" },
    2: { label: "Below average", color: "feasibility_medium" },
    3: { label: "Medium", color: "risk_low" },
    4: { label: "Above average", color: "feasibility_high" },
    5: { label: "Optimal", color: "status_resolve" },
  },
  risk: {
    1: { label: "High", color: "feasibility_low" },
    2: { label: "Medium", color: "feasibility_medium risk_low" },
    3: { label: "Low", color: "risk_low" },
    4: { label: "Minimal", color: "status_resolve" },
  },
  entity_risk: {
    1: { label: "Minimal Risk", shortLabel: "Minimal", color: "risk_minimal" },
    2: { label: "Low Risk", shortLabel: "Low", color: "risk_low" },
    3: { label: "Medium Risk", shortLabel: "Medium", color: "risk_medium" },
    4: { label: "High Risk", shortLabel: "High", color: "risk_high" },
    5: {
      label: "Critical Risk",
      shortLabel: "Critical",
      color: "risk_critical",
    },
  },
  tenant_risk: {
    Low: { label: "Low", color: "risk_low" },
    Medium: { label: "Medium", color: "risk_medium" },
    High: { label: "High", color: "risk_high" },
    Critical: {
      label: "Critical",
      color: "risk_critical",
    },
  },
  autoRemediationLogStatus: {
    [ActivityLogType.AUTO_RESOLVED]: {
      label: "Auto Resolved",
      color: "auto_remediation_log_status_auto_resolved",
    },
    [ActivityLogType.PARTIALLY_APPLIED]: {
      label: "Partially Applied",
      color: "auto_remediation_log_status_partially_applied",
    },
    [ActivityLogType.ROLLED_BACK]: {
      label: "Rolled back",
      color: "auto_remediation_log_status_rolled_back",
    },
  },
  // ...other types
};
export function getRemediationPropLabel(type, value) {
  let labelExists = Object.keys(RemediationTypeChip).includes(type);
  if (!labelExists) return "";
  return RemediationTypeChip[type][value].label || "";
}
export const getRemediationKeyFromLabel = (type, label) => {
  if (RemediationTypeChip[type]) {
    for (const key in RemediationTypeChip[type]) {
      if (RemediationTypeChip[type][key].label === label) {
        return key;
      }
    }
  }
  return null;
};

export const VulnerabilityTypeChip = {
  vulnerabilitySeverity: {
    LOW: { label: "Low", color: "risk_low", value: 1 },
    MEDIUM: {
      label: "Medium",
      color: "risk_medium",
      value: 2,
    },
    HIGH: { label: "High", color: "risk_high", value: 3 },
    CRITICAL: {
      label: "Critical",
      color: "risk_critical",
      value: 4,
    },
  },

  // ...other types
};
export const breezeScoreToLabel = (score) => {
  if (score <= 2.5) return { label: "Low", color: "risk_low", value: 1 };
  if (score <= 5)
    return {
      label: "Medium",
      color: "risk_medium",
      value: 2,
    };
  if (score <= 7.5) return { label: "High", color: "risk_high", value: 3 };
  return {
    label: "Critical",
    color: "risk_critical",
    value: 4,
  };
};
